import { DefaultTableColumns } from '../constants/OverviewTableConstants';
import { SortValues } from '../constants/SortValues';
import { SET_REP_OVERVIEW_TABLE_SORT } from '../actions/ActionTypes';
const initialState = {
  repOverviewTableSort: {
    columnKey: DefaultTableColumns.ATTAINMENT,
    sortValue: SortValues.DESCENDING
  }
};
export default function sorts(state = initialState, action) {
  const {
    payload
  } = action;
  switch (action.type) {
    case SET_REP_OVERVIEW_TABLE_SORT:
      return Object.assign({}, state, {
        repOverviewTableSort: payload
      });
    default:
      return state;
  }
}